export default {
    isToken(value){
        if(value.length == 40){
            return true
        }
        return false
    }
}


// WEBPACK FOOTER //
// ./src/services/formValidators.js